import React from 'react';

const PartnerTableProductsCell = ({ products = [], rowKeyPrefix = 'project' }) => {
  const list = (products || []).filter(Boolean);
  const visible = list.slice(0, 2);
  const remainder = list.slice(2);

  return (
    <>
      <div className="partner-product-tags">
        {visible.map((product) => (
          <span
            key={`${rowKeyPrefix}-${product}`}
            className="partner-product-tag"
            title={product}
          >
            {product}
          </span>
        ))}
      </div>
      {remainder.length ? (
        <span className="partner-product-more" title={remainder.join(', ')}>
          +{remainder.length} more
        </span>
      ) : null}
    </>
  );
};

export default PartnerTableProductsCell;
